import { faBuilding, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import UnForm from "../../../../Components/Form";
import { ListarJornadaEtapaController } from "../../../../Controllers/Geral/GestaoDeCadastros/JornadaEtapa/JornadaEtapaController";
import {
    AtualizarProdutoController,
    CadastrarProdutoController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    ICadastrarProduto,
    IEmpreendimento,
} from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { ACESSOS } from "../../../../Routes/Acessos";

interface ICadastrarEEditarProdutoProps {
    editando?: boolean;
    updateList: () => void;
    row?: IEmpreendimento;
}

export default function CadastraEEditaProduto(
    props: ICadastrarEEditarProdutoProps
) {
    const FormMethods = useForm();
    const history = useHistory();
    const redirectGestaoProdutoList =
        ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.DS_PATH;
    // const { reset } = FormMethods;
    const { editando } = props;

    const { execute: cadastrarProduto, loading: cadastrarLoading } =
        useAsyncCallback(CadastrarProdutoController);

    const { execute: atualizarProduto, loading: atualizarProdutoLoading } =
        useAsyncCallback(AtualizarProdutoController);

    const { execute: listarJornadaEtapa } = useAsyncCallback(
        () => ListarJornadaEtapaController(true),
        []
    );

    function handleCadastrarOuEditarProduto(formData: ICadastrarProduto) {
        if (!props.editando) {
            cadastrarProduto({
                ...formData,
                ID_CLASSIFICACAO_PRODUTO: 1,
                DT_AGI: formData.DT_AGI,
                DT_RECEBIMENTO_AREA_COMUM: formData.DT_RECEBIMENTO_AREA_COMUM,
                NR_TORRES: formData.NR_TORRES,
                NR_UNIDADES_TORRE: formData.NR_UNIDADES_TORRE,
                DS_TIPO_VAGA: formData.DS_TIPO_VAGA,
                DS_MURO: formData.DS_MURO,
                NR_ANDAMENTO_OBRA: formData.NR_ANDAMENTO_OBRA,
                DS_OPCAO_PLANTA: formData.DS_OPCAO_PLANTA,
                DS_FICHA_TECNICA: formData.DS_FICHA_TECNICA,
                DS_MATRICULA_IMOVEL: formData.DS_MATRICULA_IMOVEL,
                DS_PRODUTO: formData.DS_PRODUTO,
                DT_HABITESE: formData.DT_HABITESE,
                DT_INICIO_GARANTIA: formData.DT_INICIO_GARANTIA,
                DT_LANCAMENTO: formData.DT_LANCAMENTO,
                DT_PATRIMONIO_AFETACAO: formData.DT_PATRIMONIO_AFETACAO,
                DT_PREVISAO_CONCLUSAO: formData.DT_PREVISAO_CONCLUSAO,
                NR_ANDARES: formData.NR_ANDARES,
                DT_RAI: formData.DT_RAI,
                DT_DM: formData.DT_DM,
            }).then(() => {
                props.updateList();
                history.push(redirectGestaoProdutoList);
            });
        } else {
            atualizarProduto({
                ...formData,
                ID_CLASSIFICACAO_PRODUTO: 1,
                DT_AGI: formData.DT_AGI,
                DT_RECEBIMENTO_AREA_COMUM: formData.DT_RECEBIMENTO_AREA_COMUM,
                NR_TORRES: formData.NR_TORRES,
                NR_UNIDADES_TORRE: formData.NR_UNIDADES_TORRE,
                DS_TIPO_VAGA: formData.DS_TIPO_VAGA,
                DS_MURO: formData.DS_MURO,
                NR_ANDAMENTO_OBRA: formData.NR_ANDAMENTO_OBRA,
                DS_OPCAO_PLANTA: formData.DS_OPCAO_PLANTA,
                DS_FICHA_TECNICA: formData.DS_FICHA_TECNICA,
                DS_MATRICULA_IMOVEL: formData.DS_MATRICULA_IMOVEL,
                DS_PRODUTO: formData.DS_PRODUTO,
                DT_HABITESE: formData.DT_HABITESE,
                DT_INICIO_GARANTIA: formData.DT_INICIO_GARANTIA,
                DT_LANCAMENTO: formData.DT_LANCAMENTO,
                DT_PATRIMONIO_AFETACAO: formData.DT_PATRIMONIO_AFETACAO,
                DT_PREVISAO_CONCLUSAO: formData.DT_PREVISAO_CONCLUSAO,
                ID_PRODUTO: props.row?.ID_EMPREENDIMENTO ?? 0,
                NR_ANDARES: formData.NR_ANDARES,
                DT_RAI: formData.DT_RAI,
                DT_DM: formData.DT_DM,
            }).then(() => {
                props.updateList();
                history.push(redirectGestaoProdutoList);
            });
        }
    }

    return (
        <div className="row">
            <FormProvider {...FormMethods}>
                <UnForm
                    usingContext
                    handleSubmit={handleCadastrarOuEditarProduto}
                    className="card card-custom w-100 h-100"
                >
                    <h1 className="text-center pt-4">
                        {!props.editando
                            ? "Cadastrar Produto"
                            : "Editar Produto"}
                    </h1>
                    <div className="p-8">
                        <div className="row">
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    defaultValue={props.row?.DS_EMPREENDIMENTO}
                                    name="DS_PRODUTO"
                                    label="Produto"
                                    registerOptions={{
                                        required: "Insira o nome do produto",
                                    }}
                                />
                            </div>
                            {/* <div className="form-group col-6 ">
                    <UnForm.LazySelect
                        label="Classificação Produto"
                        name="ID_CLASSIFICACAO_PRODUTO"
                        defaultValue={props.row?.ID_CLASSIFICACAO_PRODUTO}
                        controller={ListarClassificacaoProdutoController}
                        getDS={(e) => e.DS_CLASSIFICACAO_PRODUTO}
                        getKeyValue={(e) => e.ID_CLASSIFICACAO_PRODUTO}
                        className="form-control"
                    />
                </div> */}
                            <div className="form-group col-3">
                                <UnForm.LazySelect
                                    controller={listarJornadaEtapa}
                                    getDS={(j) => j.DS_ETAPA_JORNADA}
                                    getKeyValue={(j) => j.ID_ETAPA_JORNADA}
                                    defaultValue={props.row?.ID_ETAPA_JORNADA}
                                    name="ID_ETAPA_JORNADA"
                                    label="Etapa da Jornada"
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    name="DS_TIPO_VAGA"
                                    label="Tipo de Vaga"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS
                                            ?.DS_TIPO_VAGA
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    name="DS_MURO"
                                    label="Muro"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS?.DS_MURO
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    name="DS_OPCAO_PLANTA"
                                    label="Opção de Planta"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS
                                            ?.DS_OPCAO_PLANTA
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    name="DS_FICHA_TECNICA"
                                    label="Ficha Técnica"
                                    defaultValue={props.row?.DS_FICHA_TECNICA}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="text"
                                    name="DS_MATRICULA_IMOVEL"
                                    label="Matrícula do Imóvel"
                                    defaultValue={
                                        props.row?.DS_MATRICULA_IMOVEL
                                    }
                                />
                            </div>

                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="number"
                                    name="NR_TORRES"
                                    label="Número de Torres"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS?.NR_TORRES
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="number"
                                    name="NR_UNIDADES_TORRE"
                                    label="Número de Unidades Torre"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS
                                            ?.NR_UNIDADES_TORRE
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="number"
                                    name="NR_ANDAMENTO_OBRA"
                                    label="Número Andamento Obra"
                                    defaultValue={
                                        props.row?.DADOS_ADICIONAIS
                                            ?.NR_ANDAMENTO_OBRA
                                    }
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="number"
                                    name="NR_ANDARES"
                                    label="Número de Andares"
                                    defaultValue={props.row?.NR_ANDARES}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_INICIO_GARANTIA"
                                    label="Inicio Garantia"
                                    defaultValue={props.row?.DT_INICIO_GARANTIA?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_AGI"
                                    label="Dt. AGI"
                                    defaultValue={props.row?.DADOS_ADICIONAIS?.DT_AGI?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_RECEBIMENTO_AREA_COMUM"
                                    label="Dt. Recebimento Area Comum"
                                    defaultValue={props.row?.DADOS_ADICIONAIS?.DT_RECEBIMENTO_AREA_COMUM?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_HABITESE"
                                    label="Dt. Habitese"
                                    defaultValue={props.row?.DT_HABITESE?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_INICIO_GARANTIA"
                                    label="Dt. Inicio Garantia"
                                    defaultValue={props.row?.DT_INICIO_GARANTIA?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_LANCAMENTO"
                                    label="Dt. Lançamento"
                                    defaultValue={props.row?.DADOS_ADICIONAIS?.DT_LANCAMENTO?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_PATRIMONIO_AFETACAO"
                                    label="Dt. Patrimônio Afetação"
                                    defaultValue={props.row?.DADOS_ADICIONAIS?.DT_PATRIMONIO_AFETACAO?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_PREVISAO_CONCLUSAO"
                                    label="Dt. Previsão Conclusão"
                                    defaultValue={props.row?.DT_PREVISAO_CONCLUSAO?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_RAI"
                                    label="Dt. da RAI"
                                    defaultValue={props.row?.DT_RAI?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>
                            <div className="form-group col-3">
                                <UnForm.Input
                                    type="date"
                                    name="DT_DM"
                                    label="Dt. da Demanda Mínima"
                                    defaultValue={props.row?.DT_DM?.substring(
                                        0,
                                        10
                                    )}
                                />
                            </div>

                            <div className="col-12 d-flex justify-content-center align-items-center">
                                <UnForm.SubmitButton
                                    outline
                                    id="dados_form_submit_button"
                                    color={editando ? "primary" : "success"}
                                    iconSize="lg"
                                    loading={
                                        cadastrarLoading ||
                                        atualizarProdutoLoading
                                    }
                                    wrapperClassName="d-flex justify-content-center align-items-center col-12"
                                    loadingSize="sm"
                                    className="font-weight-bold col-6"
                                    icon={editando ? faEdit : faBuilding}
                                >
                                    {editando
                                        ? "Editar Produto"
                                        : "Cadastrar Produto"}
                                </UnForm.SubmitButton>
                            </div>
                        </div>
                    </div>
                </UnForm>
            </FormProvider>
        </div>
    );
}
